import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-mentions-legales',
  templateUrl: './mentions-legales.component.html'
})

export class MentionsLegalesComponent {

  oradea = false;
  public constructor() {
    this.oradea = (environment.codeApporteur === 'ORADEA');
  }

}



// WEBPACK FOOTER //
// ./src/app/mentions-legales/mentions-legales.component.ts